import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import confetti from "canvas-confetti";
import { play } from "../lib/sound";
import { Gift, X, Sparkles, Gem, Star } from "lucide-react";

export default function WelcomeMission() {
  const { user, refreshUser } = useAuth();
  const [reward, setReward] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!user || user.role !== "customer" || checked) return;
    setChecked(true);
    api.get("/user/welcome").then(({ data }) => {
      if (data && (data.title || data.badge)) {
        setReward(data);
        play("mission_completed");
        confetti({ particleCount: 160, spread: 90, origin: { y: 0.4 }, colors: ["#00E676", "#FFD700", "#7DF9FF"] });
        setTimeout(() => confetti({ particleCount: 90, spread: 110, origin: { y: 0.3 } }), 400);
      }
    }).catch(() => {});
  }, [user, checked]);

  const close = async () => {
    setReward(null);
    try { await api.post("/user/welcome/seen"); await refreshUser(); } catch { /* noop */ }
  };

  useEffect(() => {
    if (!reward) return;
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    const t = setTimeout(() => { close(); }, 8000);  // auto-dismiss: non blocca il primo utilizzo
    return () => { window.removeEventListener("keydown", onKey); clearTimeout(t); };
  }, [reward]);

  if (!reward) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" data-testid="welcome-mission-modal" onClick={close}>
      <div className="relative w-full max-w-md rounded-3xl border border-[#00E676]/30 bg-gradient-to-b from-[#101418] to-[#0A0A0C] p-8 text-center shadow-[0_20px_80px_rgba(0,230,118,0.25)]" onClick={(e) => e.stopPropagation()}>
        <button data-testid="welcome-close" onClick={close} className="absolute right-4 top-4 text-zinc-500 hover:text-white"><X className="h-5 w-5" /></button>
        <div className="mx-auto mb-4 h-20 w-20 rounded-full bg-[#00E676]/15 border border-[#00E676]/40 flex items-center justify-center animate-pulse"><Gift className="h-10 w-10 text-[#00E676]" /></div>
        <div className="text-3xl mb-1">🎉</div>
        <h2 className="font-['Unbounded'] font-bold text-xl text-white">Missione completata!</h2>
        <p className="text-[#00E676] font-semibold mt-1" data-testid="welcome-title">{reward.title || "Benvenuto in Fuma c'anduma!"}</p>
        <p className="text-sm text-zinc-400 mt-3">Hai sbloccato la tua prima ricompensa. Benvenuto nella community!</p>
        <div className="mt-5 flex items-center justify-center gap-3 flex-wrap">
          {reward.xp > 0 && <div data-testid="welcome-xp" className="rounded-xl bg-white/5 border border-white/10 px-4 py-2"><div className="flex items-center gap-1.5 text-[#7DF9FF] font-bold"><Sparkles className="h-4 w-4" /> +{reward.xp} XP</div></div>}
          {reward.credits > 0 && <div data-testid="welcome-credits" className="rounded-xl bg-white/5 border border-white/10 px-4 py-2"><div className="flex items-center gap-1.5 text-[#C4B5FD] font-bold"><Gem className="h-4 w-4" /> +{reward.credits} crediti</div></div>}
        </div>
        {reward.badge_label && <div data-testid="welcome-badge" className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#FFD700]/10 border border-[#FFD700]/30 px-4 py-1.5 text-[#FFD700] text-sm font-medium"><Star className="h-4 w-4" /> Badge «{reward.badge_label}»</div>}
        <button data-testid="welcome-continue" onClick={close} className="mt-6 w-full rounded-full bg-[#00E676] text-black font-semibold py-3 active:scale-95 transition-transform">Continua l'avventura</button>
      </div>
    </div>
  );
}
